import React, { useState } from "react";
import ProgramsInfo from "../components/Programs/ProgramsInfo";
import Aside from "../modules/SideNav/Aside";

function ProgramsInfoLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <ProgramsInfo handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default ProgramsInfoLayout;
